export type PostCommentsProps = {
  ownerCollectionId: number
  canUserComment?: boolean
  isCommentsEnabled?: boolean
  authorName?: string
  authorRole?: string
}

export type PathParams = {
  lang: string
  membership: string
  idPost: string
}

export enum CommentType {
  TEXT = 0,
  AUDIO = 1,
  VIDEO = 2,
  IMAGE = 3,
  SORTITION = 4,
  URL = 5,
  DOCUMENT = 6
}
